import { getWindow } from '../../../../utils/getWindow';
import { getAppPathPrefix } from '../../../../utils/legacyAppPath';

export const getAuthUrl = () => {
    const clientId = process.env.REACT_APP_DIRECT_OAUTH_CLIENT_ID;
    // todo: INSPIRE-8862: обновить allowlist redirect_uri OAuth Direct-клиента
    // на https://rythm.yandex.ru/promotion.
    const location = getWindow()?.location;
    const redirectUrl = `${location?.origin}${getAppPathPrefix(
        location?.pathname ?? '/',
    )}/promotion`;

    return `https://oauth.yandex.ru/authorize?response_type=token&client_id=${clientId}&redirect_uri=${redirectUrl}`;
};
